import { render, staticRenderFns } from "./CoursesSectionAdmin.vue?vue&type=template&id=d9310d12&scoped=true"
import script from "./CoursesSectionAdmin.vue?vue&type=script&lang=js"
export * from "./CoursesSectionAdmin.vue?vue&type=script&lang=js"
import style0 from "./CoursesSectionAdmin.vue?vue&type=style&index=0&id=d9310d12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9310d12",
  null
  
)

export default component.exports